import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import * as _ from 'lodash';
import { DetailsService } from 'src/app/services/details.service';

declare var $: any;
declare var jQuery: any;
@Component({
  selector: 'app-upsiemaillogdetails',
  templateUrl: './upsiemaillogdetails.component.html',
  styleUrls: ['./upsiemaillogdetails.component.css']
})
export class UpsiemaillogdetailsComponent implements OnInit {
  EmailsLogs:any;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  @Input() public _id;
  constructor(private detailsService: DetailsService,    public activeModal: NgbActiveModal,) { }

  ngOnInit(): void {
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var paramData = {
      companyID: companyDetails.companyID,
      _id:this._id
    }
    this.dtOptions = {
      processing: true,
      serverSide: false,
      scrollX: true,
      deferRender: true,
      stateSave: true,
      stateDuration: -1,
      scrollY: "420px",
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [5, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      

  }
    this.detailsService.getEmailsLog(paramData).subscribe((emails:any) => {
      this.EmailsLogs =  emails.data;
      this.dtTrigger.next();
    })
  }


  viewEmails(data,CreatedDate){
let date = new Date(CreatedDate).getDate() + '-' + (new Date(CreatedDate).getMonth() + 1) + '-' + new Date(CreatedDate).getFullYear(); 
    $("#htmldata").html(data);
    $("#sentdate").html(date);
    $("#ViewHtmlEmail").modal('show')

  }

}
